export function buildContactsPageURL() {
  return '/contacts'
}
